import { useContext, useEffect } from 'react';
import UserService from 'services/userService';
import SiteService from 'services/siteService';
import Helpers from 'utils/helpers';
import AuthContext from 'contexts/authContext';
import AppContext from 'contexts/appContext';

export default function LoginPortal(props) {
  const { authState, setAuthLoggedIn } = useContext(AuthContext);
  const { setAppLoggedIn } = useContext(AppContext);

  const redirect = () => {
    const redirectPath = props.location.pathname.toLowerCase().replace('/loginportal', '');
    const newPath = Helpers.String.isEmpty(redirectPath) ? '/' : redirectPath;
    props.history.push(newPath);
  };

  const redirectToLogin = () => {
    //setTimeout(() => {
    props.history.replace('/Login');
    //}, 2000);
  };

  async function executeLogin() {
    const token = Helpers.Url.getUrlParameter('t');
    if (!token || token.length === 0) {
      redirectToLogin();
    }
    if (token && token !== authState.token) {
      UserService.API.getAccountDetails(token).then((account) => {
        SiteService.API.getUserHierarchyTree(token).then((hierarchyData) => {
          setAuthLoggedIn(token, account.user, account.permissions, hierarchyData, 'portal');
          setAppLoggedIn();
          redirect();
        });
      });
    }
    else {
      console.log('Using existing session');
      redirect();
    }
  };

  useEffect(() => {
    executeLogin();
  });

  return null;
}
